/**
 * Warnstreifen, solange der Mailversand eingeschränkt ist.
 *
 * Der eigentliche Grund für diesen Baustein: eine Sperre wird gesetzt, um
 * eine Datenübernahme zu machen — und dann vergessen. Zwei Wochen später
 * wundert sich jemand, warum keine Terminanfrage mehr ankommt, und niemand
 * denkt an einen Schalter, den er im März umgelegt hat.
 *
 * Deshalb steht er ganz oben, auf jeder Seite, für jeden — auch für den
 * Prüfer. Wer eine Terminzusage verschickt, muss wissen, dass sie gerade
 * nicht hinausgeht.
 *
 * Er ist nicht wegklickbar. Ein Hinweis, den man wegklicken kann, ist beim
 * zweiten Mal weg, und genau dann wäre er nötig.
 */

import { Link } from 'react-router-dom'
import { VERSANDMODUSTEXT, useVersand } from '../api/kundenakte'
import { darfVerwalten, useKonto } from '../konto/KontoKontext'

export function Versandhinweis() {
  const { konto } = useKonto()
  const stand = useVersand()

  if (!konto || !stand.data?.eingeschraenkt) return null

  const { modus, umleitung_an, unterdrueckt_7_tage } = stand.data

  return (
    <div
      role="status"
      className="border-b-2 border-stufe-2 bg-stufe-2-grund px-4 py-2 text-stufe-2"
    >
      <div className="mx-auto flex max-w-5xl flex-wrap items-center gap-x-3 gap-y-1">
        <span aria-hidden className="text-lg leading-none">
          ✉
        </span>
        <span className="font-bold">Mailversand eingeschränkt</span>
        <span className="text-base">
          {VERSANDMODUSTEXT[modus]}
          {modus === 'umleitung' && umleitung_an ? ` (${umleitung_an})` : ''}
          {unterdrueckt_7_tage > 0
            ? ` · ${unterdrueckt_7_tage} ${
                unterdrueckt_7_tage === 1 ? 'Nachricht' : 'Nachrichten'
              } in 7 Tagen zurückgehalten`
            : ''}
        </span>
        {darfVerwalten(konto) && (
          <Link to="/verwaltung" className="ml-auto text-base font-semibold underline">
            Ändern
          </Link>
        )}
      </div>
    </div>
  )
}
